"use strict";

var _regeneratorRuntime = require("/app/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass.js").default;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var BottleneckError, LocalDatastore, parser;
parser = require("./parser");
BottleneckError = require("./BottleneckError");

LocalDatastore = /*#__PURE__*/function () {
  function LocalDatastore(instance, storeOptions, storeInstanceOptions) {
    _classCallCheck(this, LocalDatastore);

    this.instance = instance;
    this.storeOptions = storeOptions;
    this.clientId = this.instance._randomIndex();
    parser.load(storeInstanceOptions, storeInstanceOptions, this);
    this._nextRequest = this._lastReservoirRefresh = this._lastReservoirIncrease = Date.now();
    this._running = 0;
    this._done = 0;
    this._unblockTime = 0;
    this.ready = this.Promise.resolve();
    this.clients = {};

    this._startHeartbeat();
  }

  _createClass(LocalDatastore, [{
    key: "_startHeartbeat",
    value: function _startHeartbeat() {
      var _this14 = this;

      var base;

      if (this.heartbeat == null && (this.storeOptions.reservoirRefreshInterval != null && this.storeOptions.reservoirRefreshAmount != null || this.storeOptions.reservoirIncreaseInterval != null && this.storeOptions.reservoirIncreaseAmount != null)) {
        return typeof (base = this.heartbeat = setInterval(function () {
          var amount, incr, maximum, now, reservoir;
          now = Date.now();

          if (_this14.storeOptions.reservoirRefreshInterval != null && now >= _this14._lastReservoirRefresh + _this14.storeOptions.reservoirRefreshInterval) {
            _this14._lastReservoirRefresh = now;
            _this14.storeOptions.reservoir = _this14.storeOptions.reservoirRefreshAmount;

            _this14.instance._drainAll(_this14.computeCapacity());
          }

          if (_this14.storeOptions.reservoirIncreaseInterval != null && now >= _this14._lastReservoirIncrease + _this14.storeOptions.reservoirIncreaseInterval) {
            var _this$storeOptions = _this14.storeOptions;
            amount = _this$storeOptions.reservoirIncreaseAmount;
            maximum = _this$storeOptions.reservoirIncreaseMaximum;
            reservoir = _this$storeOptions.reservoir;
            _this14._lastReservoirIncrease = now;
            incr = maximum != null ? Math.min(amount, maximum - reservoir) : amount;

            if (incr > 0) {
              _this14.storeOptions.reservoir += incr;
              return _this14.instance._drainAll(_this14.computeCapacity());
            }
          }
        }, this.heartbeatInterval)).unref === "function" ? base.unref() : void 0;
      } else {
        return clearInterval(this.heartbeat);
      }
    }
  }, {
    key: "__publish__",
    value: function __publish__(message) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.yieldLoop();

              case 2:
                return _context.abrupt("return", _this.instance.Events.trigger("message", message.toString()));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }, {
    key: "__disconnect__",
    value: function __disconnect__(flush) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.yieldLoop();

              case 2:
                clearInterval(_this2.heartbeat);
                return _context2.abrupt("return", _this2.Promise.resolve());

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }, {
    key: "yieldLoop",
    value: function yieldLoop() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return new this.Promise(function (resolve, reject) {
        return setTimeout(resolve, t);
      });
    }
  }, {
    key: "computePenalty",
    value: function computePenalty() {
      var ref;
      return (ref = this.storeOptions.penalty) != null ? ref : 15 * this.storeOptions.minTime || 5000;
    }
  }, {
    key: "__updateSettings__",
    value: function __updateSettings__(options) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.yieldLoop();

              case 2:
                parser.overwrite(options, options, _this3.storeOptions);

                _this3._startHeartbeat();

                _this3.instance._drainAll(_this3.computeCapacity());

                return _context3.abrupt("return", true);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }, {
    key: "__running__",
    value: function __running__() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.yieldLoop();

              case 2:
                return _context4.abrupt("return", _this4._running);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }, {
    key: "__queued__",
    value: function __queued__() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this5.yieldLoop();

              case 2:
                return _context5.abrupt("return", _this5.instance.queued());

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  }, {
    key: "__done__",
    value: function __done__() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this6.yieldLoop();

              case 2:
                return _context6.abrupt("return", _this6._done);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  }, {
    key: "__groupCheck__",
    value: function __groupCheck__(time) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this7.yieldLoop();

              case 2:
                return _context7.abrupt("return", _this7._nextRequest + _this7.timeout < time);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    }
  }, {
    key: "computeCapacity",
    value: function computeCapacity() {
      var maxConcurrent, reservoir;
      var _this$storeOptions2 = this.storeOptions;
      maxConcurrent = _this$storeOptions2.maxConcurrent;
      reservoir = _this$storeOptions2.reservoir;

      if (maxConcurrent != null && reservoir != null) {
        return Math.min(maxConcurrent - this._running, reservoir);
      } else if (maxConcurrent != null) {
        return maxConcurrent - this._running;
      } else if (reservoir != null) {
        return reservoir;
      } else {
        return null;
      }
    }
  }, {
    key: "conditionsCheck",
    value: function conditionsCheck(weight) {
      var capacity;
      capacity = this.computeCapacity();
      return capacity == null || weight <= capacity;
    }
  }, {
    key: "__incrementReservoir__",
    value: function __incrementReservoir__(incr) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var reservoir;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this8.yieldLoop();

              case 2:
                reservoir = _this8.storeOptions.reservoir += incr;

                _this8.instance._drainAll(_this8.computeCapacity());

                return _context8.abrupt("return", reservoir);

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    }
  }, {
    key: "__currentReservoir__",
    value: function __currentReservoir__() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this9.yieldLoop();

              case 2:
                return _context9.abrupt("return", _this9.storeOptions.reservoir);

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    }
  }, {
    key: "isBlocked",
    value: function isBlocked(now) {
      return this._unblockTime >= now;
    }
  }, {
    key: "check",
    value: function check(weight, now) {
      return this.conditionsCheck(weight) && this._nextRequest - now <= 0;
    }
  }, {
    key: "__check__",
    value: function __check__(weight) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var now;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return _this10.yieldLoop();

              case 2:
                now = Date.now();
                return _context10.abrupt("return", _this10.check(weight, now));

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    }
  }, {
    key: "__register__",
    value: function __register__(index, weight, expiration) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var now, wait;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return _this11.yieldLoop();

              case 2:
                now = Date.now();

                if (!_this11.conditionsCheck(weight)) {
                  _context11.next = 11;
                  break;
                }

                _this11._running += weight;

                if (_this11.storeOptions.reservoir != null) {
                  _this11.storeOptions.reservoir -= weight;
                }

                wait = Math.max(_this11._nextRequest - now, 0);
                _this11._nextRequest = now + wait + _this11.storeOptions.minTime;
                return _context11.abrupt("return", {
                  success: true,
                  wait: wait,
                  reservoir: _this11.storeOptions.reservoir
                });

              case 11:
                return _context11.abrupt("return", {
                  success: false
                });

              case 12:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    }
  }, {
    key: "strategyIsBlock",
    value: function strategyIsBlock() {
      return this.storeOptions.strategy === 3;
    }
  }, {
    key: "__submit__",
    value: function __submit__(queueLength, weight) {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var blocked, now, reachedHWM;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return _this12.yieldLoop();

              case 2:
                if (!(_this12.storeOptions.maxConcurrent != null && weight > _this12.storeOptions.maxConcurrent)) {
                  _context12.next = 4;
                  break;
                }

                throw new BottleneckError("Impossible to add a job having a weight of ".concat(weight, " to a limiter having a maxConcurrent setting of ").concat(_this12.storeOptions.maxConcurrent));

              case 4:
                now = Date.now();
                reachedHWM = _this12.storeOptions.highWater != null && queueLength === _this12.storeOptions.highWater && !_this12.check(weight, now);
                blocked = _this12.strategyIsBlock() && (reachedHWM || _this12.isBlocked(now));

                if (blocked) {
                  _this12._unblockTime = now + _this12.computePenalty();
                  _this12._nextRequest = _this12._unblockTime + _this12.storeOptions.minTime;

                  _this12.instance._dropAllQueued();
                }

                return _context12.abrupt("return", {
                  reachedHWM: reachedHWM,
                  blocked: blocked,
                  strategy: _this12.storeOptions.strategy
                });

              case 9:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    }
  }, {
    key: "__free__",
    value: function __free__(index, weight) {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return _this13.yieldLoop();

              case 2:
                _this13._running -= weight;
                _this13._done += weight;

                _this13.instance._drainAll(_this13.computeCapacity());

                return _context13.abrupt("return", {
                  running: _this13._running
                });

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }))();
    }
  }]);

  return LocalDatastore;
}();

module.exports = LocalDatastore;